import { FormInput } from "@/types/Common"
import { TenpuFile } from "@/types/TenpuFile"
import { BaseOption } from "@/types/Option"

/* 一覧用：社員マスタ情報 */
export interface ListData {
  user_id: number | null
  staff_code: number | null
  staff_name: string | null
  staff_kana: string | null
  birthday_date: Date | null
  nyuusya_date: Date | null
  is_web_meisai: boolean | null
  hokensyou_no: number | null
  notes: string | null
  taisyoku_date: Date | null
  koyou_keiyaku_id: number | null
  yakusyoku_name: string | null
  syozoku_name: string | null
  shikaku_notes: string | null
  mst_roll_id: number | null
  role_name: string | null
  // 以下、Service側付加項目
  keiyakuDate: Date | string | null
  syaho: string | null
  koyou: string | null
  keitai: string | null
  syubetsu: string | null
  shimeDay: string | null
  koutsuuhi: string | null
  webMeisai: string | null
  syuugyouBasyoName: string | null
  bukaName: string | null
  age: string | null
  kinzokuNensuu: string | null
  kinzokuNissuu: string | null
}

/* 更新用：社員マスタ情報 */
export interface DetailInputData extends FormInput, DetailCommonData {
  role_name: string | null
}

/**
 * その他休日
 */
export interface SonotaKyuujitsu {
  user_id: number | null
  start_date: Date | null
  end_date: Date | null
  sonota_kyuujitsu_type: number | null
}

/**
 * 検索項目
 */
export interface SearchForm extends FormInput {
  syozokuId: number | null
  kana: string | null
  shikaku: string | null
  mst_role_id: number | null
}

/* 社員マスタ情報（共通） */
class DetailCommonData {
  user_id: number | null = null
  staff_code: number | null = null
  staff_name: string | null = null
  staff_kana: string | null = null
  gender_type: number | null = null
  birthday_date: string | null = null
  address: string | null = null
  zip_code: string | null = null
  email: string | null = null
  tel: string | null = null
  keitai_tel: string | null = null
  emergency_name: string | null = null
  emergency_tel: string | null = null
  is_drivers_license: boolean | null = null
  drivers_license: string | null = null
  hokensyou_no: string | null = null
  is_web_meisai: boolean | null = null
  kinmu_status: string | null = null
  notes: string | null = null
  koyou_hoken: string | null = null
  nenkin_bangou: string | null = null
  web_mitaiou_notes: string | null = null
  last_logined_at: Date | null = null
  nyuusya_date: Date | null = null
  yuukyuu_reference_date: Date | null = null
  taisyoku_date: Date | null = null
  kinmu_status_type: number | null = null  
  last_available_day: Date | null = null
  tenpufiles: TenpuFile[] | null = null
  sonota_kyuujitus: SonotaKyuujitsu[] | null = null
  mst_yakusyoku_id: number | null = null
  mst_role_id: number | null = null
  shikaku_notes: string | null = null
  idoureki_notes: string | null = null
  koyou_keiyaku_notes: string | null = null
  mst_syozoku_id: number | null = null
  is_force_logout: boolean = false
  has_yuukyuu_fuyu: boolean = false
}

/* 詳細用：社員マスタ情報 */
export class DetailData extends DetailCommonData {
  yakusyoku_name: string | null = null
  role_name: string | null = null
  syozoku_name: string | null = null
  // 以下、Service側付加項目
  kinmuStatus: string | null = null
  driversLicense: string | null = null
  webMeisai: string | null = null
  gender: string | null = null
  keitai: string | null = null
  zipCode: string | null = null
}

/**
 * 社員マスタオプション
 */
export interface SyainOptions {
  mst_syozoku: BaseOption[]
  syuugyou_basyo: BaseOption[]
  mst_yakusyoku: BaseOption[]
  mst_role: BaseOption[]
}

/**
 * TODO: 遷移前情報
 */
export interface DetailInfo {
  koyouKeiyakuId: number | null
  tab: string | null
}

export interface Syain{
  user_id: number,
  staff_name: string,
  staff_code: string,
  mst_syozoku_id: number | null,
  staff_kana: string,
  nyuusya_date: Date | string | null,
  mst_yakusyoku_id: number | null
}